import {
  getNeedsAnalysisApi, getSBCombinePremiumApi,
  getSbNeedsAnalysisApi,
  postSbNeedsAnalysisApi,
  updateSbNeedsAnalysisApi
} from "@/func/api"
import router from "@/router";
import {dispatch, make} from 'vuex-pathify'


const state = function () {
  return {
    show: {
      retire_1: true,
      retire_2: false,
      retire_3: false,
      retire_4: false,
      retire_5: false,
      retire_form: false,
    },
    averageLife: {
      'MALE': 78,
      'FEMALE': 84,
    },
    cost: [],
    interestsCost: 0,
    nativeTimes: 0,
    abroadTimes: 0,
    options: {},
    formData: {},
    result: {},
    premium_1:0,
    premium_2:0,
  }
}

const mutations = make.mutations(state)

const actions = {
  
  // ...make.actions(state),方便但可能難維護
  ...make.actions([
    'interestsCost',
    'nativeTimes',
    'abroadTimes',
    'formData',
    'result',
  ]),
  
  async sendRetireApi({commit, dispatch, getters}, payload) {
    try {
      //TRIPLE I 更改預設值 example.
      payload.payType = 'ONCE'
      // payload.roiOfRetire=0.0225
      // payload.growthRateOfSalary=0.005
      // payload.inflationRate=0.03
      payload.alreadyPreparePerYear = 0
      //-----------------
      dispatch('setFormData', payload)
      const res = await getNeedsAnalysisApi(payload);
      res.data.stillLackAmount = res.data.stillLackAmount > 0 ? res.data.stillLackAmount : 0
      dispatch('setResult', res.data)
    } catch (e) {
      alert('發生了些問題' + e)
    }
  },
  
  sendSBApi({state}) {
    let result = {
      abroadTimes: state.abroadTimes,
      nativeTimes: state.nativeTimes,
      food_abroadCost: state.cost.food.abroadCost,
      food_nativeCost: state.cost.food.nativeCost,
      food_normalCost: state.cost.food.normalCost,
      trans_abroadCost: state.cost.trans.abroadCost,
      trans_nativeCost: state.cost.trans.nativeCost,
      trans_normalCost: state.cost.trans.normalCost,
      formData_gender: state.formData.gender,
      formData_currentAge: state.formData.currentAge,
      formData_currentSalary: state.formData.currentSalary,
      formData_alreadyPrepare: state.formData.alreadyPrepare,
      formData_estimateRetireAge: state.formData.estimateRetireAge,
      formData_startWorkAge: state.formData.startWorkAge,
      formData_interestsCost: state.interestsCost,
      premium_1: state.premium_1,
      premium_2: state.premium_2,
      wantCostAfterRetirePerMonth: state.formData.wantCostAfterRetirePerMonth,
      costAfterRetire: state.result.costAfterRetire,
      laborProtectionAmount: state.result.laborProtectionAmount,
      laborRebateAmount: state.result.laborRebateAmount,
      stillLackAmount: state.result.stillLackAmount,
      saveAmountPerMonth: state.result.saveAmountPerMonth,
      saveAmountPerYear: state.result.saveAmountPerYear,
      a: state.result.a,
      b: state.result.b,
      c: state.result.c,
      d: state.result.d,
      h_amount: state.result.hotProduct.amount,
      h_currency: state.result.hotProduct.currency,
      h_payYear: state.result.hotProduct.payYear,
      h_remark: state.result.hotProduct.remark,
      h_getAmount: state.result.hotProduct.getAmount,
      h_apiCalFormList: JSON.stringify(state.result.hotProduct.apiCalFormList),
      p_amount: state.result.personalProduct.amount,
      p_currency: state.result.personalProduct.currency,
      p_payYear: state.result.personalProduct.payYear,
      p_remark: state.result.personalProduct.remark,
      p_getAmount: state.result.personalProduct.getAmount,
      p_apiCalFormList: JSON.stringify(state.result.personalProduct.apiCalFormList),
      na_op1: state.options.option1,
      na_op2: state.options.option2,
      na_op3: state.options.option3,
      na_op4_1: state.options.option4_1,
      na_op4_2: state.options.option4_2,
    }
    // 方案對應之商品名稱
    let resultProductName = {
      plan1: state.result.hotProduct.productName,
      plan2: state.result.personalProduct.productName
    }
    result.selectedProduct = JSON.stringify(resultProductName)
    return postSbNeedsAnalysisApi(result).then(res => {
      if (res.data) {
        return res.data.a_uniqid;
      } else {
        return router.push(`/needs_analysis/`).catch((e) => {
          alert('好像發生了些問題' + e)
        })
      }
    })
  },
  
  async updateSBApi({state, getters, dispatch}, payload) {
  
    await dispatch('sendSBCombinePremiumApi')
    
    let result = {
      //基本資料
      a_uniqid: payload.token,
      formData_gender: state.formData.gender,
      formData_currentAge: state.formData.currentAge,
      formData_currentSalary: state.formData.currentSalary,
      formData_alreadyPrepare: state.formData.alreadyPrepare,
      formData_estimateRetireAge: state.formData.estimateRetireAge,
      formData_startWorkAge: state.formData.startWorkAge,
      wantCostAfterRetirePerMonth: state.formData.wantCostAfterRetirePerMonth,
      RetireNeedMonth: getters.getRetireNeedMonth,
      selectedProduct: state.result.selectedProduct,
      costAfterRetire: state.result.costAfterRetire,
      laborProtectionAmount: state.result.laborProtectionAmount,
      laborRebateAmount: state.result.laborRebateAmount,
      stillLackAmount: state.result.stillLackAmount,
      saveAmountPerMonth: state.result.saveAmountPerMonth,
      saveAmountPerYear: state.result.saveAmountPerYear,
      a: state.result.a,
      b: state.result.b,
      c: state.result.c,
      d: state.result.d,
      h_amount: state.result.h_amount,
      h_currency: state.result.h_currency,
      h_payYear: state.result.h_payYear,
      h_remark: state.result.h_remark,
      h_getAmount: state.result.h_getAmount,
      h_apiCalFormList: state.result.h_apiCalFormList,
      p_amount: state.result.p_amount,
      p_currency: state.result.p_currency,
      p_payYear: state.result.p_payYear,
      p_remark: state.result.p_remark,
      p_getAmount: state.result.p_getAmount,
      p_apiCalFormList: state.result.p_apiCalFormList,
      form_plan: state.result.form_plan,
      //調整花費項目
      food_normalCost: payload.food_normalCost,
      trans_normalCost: payload.trans_normalCost,
      formData_interestsCost: payload.formData_interestsCost,
      formData_travelCost: payload.formData_travelCost,
      premium_1: state.premium_1,
      premium_2: state.premium_2,
    }
    return updateSbNeedsAnalysisApi(result).then(res => {
      if (res.data) {
        return res.data
      }
    }).catch(e => {
      alert('好像發生了些問題' + e)
      return router.push(`/needs_analysis`).catch(() => {
      })
    })
  },
  
  async getSBApi({commit, getters, state}, payload) {
    const res = await getSbNeedsAnalysisApi(payload)
    if (res.data) {
      commit('result', res.data)
      res.data.formData_travelCost = res.data.formData_travelCost ?
                                     res.data.formData_travelCost :
                                     getters.getTravelCost
      let formData = {
        gender: res.data.formData_gender,
        currentAge: res.data.formData_currentAge,
        currentSalary: res.data.formData_currentSalary,
        alreadyPrepare: res.data.formData_alreadyPrepare,
        estimateRetireAge: res.data.formData_estimateRetireAge,
        startWorkAge: res.data.formData_startWorkAge,
      }
      commit('formData', formData)
      commit('interestsCost', res.data.formData_interestsCost)
      commit('premium_1', res.data.premium_1)
      commit('premium_2', res.data.premium_2)
    } else {
      router.push(`/needs_analysis/`).catch((e) => alert('好像查詢不到紀錄喔！' + e))
    }
  },
  
  async sendSBCombinePremiumApi({state, commit}) {
    let token_1 = '3101e3deabbbf9138c84235df233cb7a'
    let token_2 = '1e289442d706773512f320c8f441c1c0'
    
    if (state.formData.currentAge <= 30) {
      token_1 = '7f5431c5174d58d1d87d7a9a08a54f62'
      token_2 = 'cefa514f21d42db85d5169cbfda1738b'
  
    } else if (state.formData.currentAge <= 45) {
      token_1 = '1b61f6dd44a1a40cf4245669624227e2'
      token_2 = '592ae6ff4fceebbafbffdadb3f87df3c'
    }
    
    let premium_1_data = {
      gender: state.formData.gender === "MALE" ? 1 : 2,
      age: state.formData.currentAge,
      job: 1,
      id: token_1,
    }
    let premium_2_data = {
      gender: state.formData.gender === "MALE" ? 1 : 2,
      age: state.formData.currentAge,
      job: 1,
      id: token_2,
    }
    
    const premium_1 = await getSBCombinePremiumApi(premium_1_data)
    const premium_2 = await getSBCombinePremiumApi(premium_2_data)
    commit('premium_1', premium_1.data)
    commit('premium_2', premium_2.data)
  },
  
  
  addOption(context, {optionNo, option}) {
    let options = context.state.options
    options[optionNo] = option
    context.commit('options', options)
  },
  
  changeShow(context, {from, to}) {
    let show = context.state.show
    show[from] = !show[from]
    show[to] = !show[to]
    context.commit('show', show)
  },
  
  defaultShow(context, payload) {
    context.commit('show', payload)
  },
  
  addCostTrans(context, payload) {
    let cost = context.state.cost
    cost.trans = payload
    context.commit('cost', cost)
  },
  
  addCostFood(context, payload) {
    let cost = context.state.cost
    cost.food = payload
    context.commit('cost', cost)
  },
  
  setFormPlan(context, payload) {
    let result = context.state.result
    result.form_plan = payload
    context.commit('result', result)
  }
}

const getters = {
  getWantCost(state) {
    return Math.round(state.cost.food.normalCost +
      state.cost.trans.normalCost +
      state.interestsCost +
      (state.cost.food.nativeCost) * state.nativeTimes / 12 +
      (state.cost.food.abroadCost) * state.abroadTimes / 12)
  },
  
  getWantCostResult(state) {
    return Math.round(state.result.wantCostAfterRetirePerMonth)
  },
  
  getRetireNeedMonth(state) {
    let retireNeedMonth = Math.round((
        state.result.costAfterRetire -
        state.result.formData_alreadyPrepare -
        state.result.laborProtectionAmount -
        state.result.laborRebateAmount) /
       (state.result.formData_estimateRetireAge -
        state.result.formData_currentAge) / 12)

    return retireNeedMonth > 0 ? retireNeedMonth : 0
  },
  
  getRetireNeed(state) {
    let retireNeed = Math.round(
      state.result.costAfterRetire -
      state.result.formData_alreadyPrepare -
      state.result.laborProtectionAmount -
      state.result.laborRebateAmount)
  
    return retireNeed > 0 ? retireNeed : 0
  },
  
  getTravelCost(state) {
    return Math.round(
      (state.result.food_nativeCost) * state.result.nativeTimes / 12 +
      (state.result.food_abroadCost) * state.result.abroadTimes / 12)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}